export interface INameExistenceFiltration {
    name: string;
    id: string;
    owner: string;
}
